
import { Component, Prop, Vue } from 'vue-property-decorator'
import { type OpenMiniProgramOptionType, openMiniProgram } from '@xt/client/utils/mini'

@Component({
  components: {}
})
export default class PageView extends Vue {
  @Prop({ default: false }) visible: boolean
  @Prop({ default: '' }) title: string
  @Prop({ default: '' }) subTitle: string
  @Prop({ default: '' }) qrcodeUrl: string
  @Prop({ default: '' }) scanTip: string
  @Prop() openMiniProgramOption: OpenMiniProgramOptionType

  async handleOpenPCMini() {
    const { miniProgrmType, path, query } = this.openMiniProgramOption
    const { success, reason } = await openMiniProgram(miniProgrmType, path ?? '', query)

    console.warn(success, reason)

    if (reason) {
      this.$message.error(reason)
    }
  }

  onCancel() {
    this.$emit('closeWxImgPop')
  }
  created() {}
}
